import React, { useState, useEffect } from "react";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);

  // Fetch contact data from the API
  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/contact`);
        if (response.ok) {
          const data = await response.json();
          setContacts(data);
          setError("");
        } else {
          throw new Error("Failed to fetch contacts");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchContacts();
  }, []);

  // Toggle accordion state
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container mx-auto md:p-8 p-4">
      <h1 className="text-4xl font-semibold text-center mb-8 mt-4">Contact Messages</h1>

      {loading ? (
        <p className="text-center">Loading...</p>
      ) : error ? (
        <p className="text-center text-red-500">{error}</p>
      ) : (
        <div className="space-y-4">
          {contacts.length > 0 ? (
            contacts.map((contact, index) => (
              <div
                key={contact._id}
                className="bg-white shadow-md rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full flex justify-between items-center p-4 font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                >
                  <span>{index+1}.</span>
                  <span>{contact.name}</span>
                  <span className="text-sm text-gray-500">
                    {new Date(contact.createdAt).toLocaleDateString()}
                  </span>
                </button>
                {activeIndex === index && (
                  <div className="p-4 space-y-2 border-t border-gray-200 bg-gray-50">
                    <div className="text-gray-700 font-semibold">
                      Email: <span className="font-normal">{contact.email}</span>
                    </div>
                    <div className="text-gray-700 font-semibold">
                      Mobile: <span className="font-normal">{contact.mobile || "N/A"}</span>
                    </div>
                    <div className="text-gray-700 font-semibold">
                      Message: <span className="font-normal">{contact.message}</span>
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="text-center">No contact messages found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactList;
